import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		menuActive: '',
		breadcrumb: [],
		hasLogin: false,
		loginInfo: {},
    power: {}
  },
  mutations: {
		setMenuActive(state, index) {
			state.menuActive = index
		},
		setBreadcrumb(state, data) {
			state.breadcrumb = data
		},
		login(state, data) {
			state.hasLogin = true
			state.loginInfo = data
			localStorage.setItem('login', JSON.stringify(data))
		},
		logout(state) {
			state.hasLogin = false
			state.loginInfo = {}
			localStorage.removeItem('login')
		},
    setPower(state, data) {
      state.power = data
    }
  },
  actions: {
		setLogin({commit}, param) {
			commit('login', param)
		}
  }
})
